import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { StaffRole } from '../../../types';
import MobileRowActions from '../../../components/datagridComponents/MobileRowActions';

export const MobileRowMainContent = ({ data }: { data: StaffRole }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="body1" sx={{ fontWeight: 600, marginBottom: '0.25rem' }}>
          {data.name}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: '0.3rem',
            alignItems: 'center',
          }}
        >
          <Typography variant="body2">
            {t('screens.staffRoles.adminOptsBackOffice')}:
          </Typography>
          {data.adminOptsBackOffice ? (
            <CheckIcon fontSize="small" sx={{ color: 'success.main' }} />
          ) : (
            <CloseIcon fontSize="small" sx={{ color: 'icon.default' }} />
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: '0.3rem',
            alignItems: 'center',
          }}
        >
          <Typography variant="body2">
            {t('screens.staffRoles.globalTillAccess')}:
          </Typography>
          {data.globalTillAccess ? (
            <CheckIcon fontSize="small" sx={{ color: 'success.main' }} />
          ) : (
            <CloseIcon fontSize="small" sx={{ color: 'icon.default' }} />
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: '0.3rem',
            alignItems: 'center',
          }}
        >
          <Typography variant="body2">
            {t('screens.staffRoles.adminOptsTillAdmin')}:
          </Typography>
          {data.adminOptsTillAdmin ? (
            <CheckIcon fontSize="small" sx={{ color: 'success.main' }} />
          ) : (
            <CloseIcon fontSize="small" sx={{ color: 'icon.default' }} />
          )}
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-end',
          width: '20%',
          marginRight: '-0.5rem',
        }}
      >
        <MobileRowActions objectId={data.id} />
      </Box>
    </Box>
  );
};

export default MobileRowMainContent;
